import "./AboutPage.css";

const SEGMENTS = [
  {
    title: "Healthcare providers",
    needs: "Clinical decision support, EHR analytics, operational efficiency.",
    value: "Cardiac event prediction, real-world evidence pipelines, BI dashboards that match clinical workflows.",
  },
  {
    title: "Pharma & biotech",
    needs: "Drug discovery acceleration, regulatory compliance, R&D productivity.",
    value: "ML-driven target identification, BOM correction, regulatory submission assistants, knowledge engineering platforms.",
  },
  {
    title: "Cross-industry",
    needs: "AI literacy, governance, capability building.",
    value: "Executive briefings, engineering bootcamps, governance frameworks, and AI strategy advisory.",
  },
];

export function AboutPage() {
  return (
    <>
      <section className="section container">
        <header className="page-hero about-hero">
          <p className="eyebrow">About SilicoInformatics</p>
          <h1>
            Your trusted AI partner — fluent in <span className="gradient-text">medicine</span>, <span className="gradient-text">biology</span>, <span className="gradient-text">data science</span>, and <span className="gradient-text">silicon</span>.
          </h1>
          <p className="lede">
            AI solutions for healthcare and life sciences — delivered with measurable impact.
          </p>
        </header>
      </section>

      <section className="section--tight container">
        <div className="about-bio card">
          <p>
            <strong>Founded in 2023.</strong> Built on 25+ years of leadership in pharmaceutical informatics, machine learning, and life-sciences software at Celera Genomics, Eli Lilly, Johnson & Johnson, Elanco Animal Health, Dow AgroSciences, Corteva, and I.U. Health.
          </p>
          <p>
            We're a boutique specialist — not a generalist. That means deeper domain expertise, more personalized attention, and the ability to ship solutions that actually fit the operational reality of regulated life-sciences workflows.
          </p>
        </div>
      </section>

      <section className="section container">
        <div className="vm-grid">
          <div className="card vm-card">
            <p className="eyebrow">Vision</p>
            <h2>Empower businesses through trusted AI</h2>
            <p className="vm-card__body">
              Delivering transformative and measurable business value through AI solutions our partners can rely on, audit, and defend.
            </p>
          </div>
          <div className="card vm-card">
            <p className="eyebrow">Mission</p>
            <h2>Deliver measurable AI impact</h2>
            <p className="vm-card__body">
              By aligning innovative informatics solutions with strategic client objectives — never the other way around.
            </p>
          </div>
        </div>
      </section>

      <section className="section container">
        <header className="section-head">
          <p className="eyebrow">Who we serve</p>
          <h2>Three market segments. Tailored value in each.</h2>
        </header>
        <div className="grid grid--cols-3">
          {SEGMENTS.map((s) => (
            <article key={s.title} className="card card--interactive segment">
              <h3>{s.title}</h3>
              <p className="segment__label">Key needs</p>
              <p className="segment__text">{s.needs}</p>
              <p className="segment__label">Our value</p>
              <p className="segment__text">{s.value}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="section container">
        <div className="about-positioning card">
          <p className="eyebrow">Competitive position</p>
          <h2>Boutique specialist, not generalist.</h2>
          <p className="about-positioning__body">
            The big consultancies sell you methodology. The big platforms sell you generic infrastructure. We sell you outcomes — backed by domain expertise that took two decades to build and a willingness to say "no" when AI isn't the right answer.
          </p>
        </div>
      </section>
    </>
  );
}
